export default __webpack_public_path__ + "static/outward-block-a104ac856b45c9e74a3a4058ef2c5324.woff2";